import withProps from '../../containers/withProps';

const withWorkIdFromRoute = withProps(({ match }) => {
  return {
    workId: match.params.workId
  };
});

export default withWorkIdFromRoute;
